(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.headerCoords = {};
      this.calcHeaderCoords();

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
      };

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    calcHeaderCoords() {
      const clientRect = this.getBoundingClientRect();
      const pageYOffset = window.pageYOffset || document.documentElement.scrollTop;
      this.headerCoords.bottom = pageYOffset + clientRect.bottom;
      this.headerCoords.top = pageYOffset + clientRect.top;
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.headerIsAlwaysSticky) {
        if (scrollTop > this.header.offsetHeight + 1) {
          this.header.classList.add('shopify-section-header-sticky');

          if (this.header.classList.contains('color-background-overlay')) {
            this.header.classList.remove('color-background-overlay');
            this.header.classList.add('color-background-overlay-hidden');
          }
        }

        if (scrollTop < this.header.offsetHeight) {
          this.header.classList.remove('shopify-section-header-sticky');

          if (this.header.classList.contains('color-background-overlay-hidden')) {
            this.header.classList.add('color-background-overlay');
            this.header.classList.remove('color-background-overlay-hidden');
          }
        }
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerCoords.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');

      if (this.header.classList.contains('color-background-overlay')) {
        this.header.classList.remove('color-background-overlay');
        this.header.classList.add('color-background-overlay-hidden');
      }
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');

      if (this.header.classList.contains('color-background-overlay-hidden')) {
        const megaMenus = Array.from(document.querySelectorAll('.mega-menu'));
        if (megaMenus.some((megaMenu) => megaMenu.hasAttribute('open'))) return;
        this.header.classList.add('color-background-overlay');
        this.header.classList.remove('color-background-overlay-hidden');
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      if (customElements.get('details-disclosure')) {
        this.disclosures.forEach((disclosure) => {
          disclosure.close();
        });
      }

      this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
      this.disclosureLists.forEach((disclosureList) => {
        disclosureList.setAttribute('hidden', true);
      });
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const prefersReducedMotion = () =>
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    const sliderState = new WeakMap();

    const getMainEl = (root) =>
      root?.querySelector?.("[data-main-collection]") ||
      root?.closest?.("[data-main-collection]");

    const destroySlider = (mainEl) => {
      const state = sliderState.get(mainEl);
      const swiper = state?.swiper;
      if (!swiper) return;

      const layout = mainEl.querySelector(".main-collection__layout");
      const wrapper = mainEl.querySelector(".main-collection__list");
      const slides = mainEl.querySelectorAll(".main-collection__item");

      swiper.destroy(true, true);
      state.swiper = null;

      layout?.classList.remove("swiper");
      wrapper?.classList.remove("swiper-wrapper");
      for (const slide of slides) {
        slide.classList.remove("swiper-slide");
      }
    };

    const initSlider = (mainEl) => {
      if (!mainEl) return;
      if (mainEl.dataset.layoutMobile !== "slider") return;
      if (typeof Swiper === "undefined") return;

      const layout = mainEl.querySelector(".main-collection__layout");
      const wrapper = mainEl.querySelector(".main-collection__list");
      const slides = mainEl.querySelectorAll(".main-collection__item");

      if (!layout || !wrapper || !slides.length) return;

      const state = sliderState.get(mainEl) || { swiper: null, currentLayout: null, resizeObserver: null, mutationObserver: null };
      sliderState.set(mainEl, state);

      if (state.swiper) destroySlider(mainEl);

      const isVisibleOverflow = mainEl.classList.contains("main-collection--visible-overflow");
      const mobSlidesPerView = isVisibleOverflow ? "auto" : 1;

      layout.classList.add("swiper");
      wrapper.classList.add("swiper-wrapper");
      for (const slide of slides) {
        slide.classList.add("swiper-slide");
      }

      const nextBtn = mainEl.querySelector(".main-collection__navigation-button-next");
      const prevBtn = mainEl.querySelector(".main-collection__navigation-button-prev");

      state.swiper = new Swiper(layout, {
        slidesPerView: mobSlidesPerView,
        spaceBetween: 16,
        speed: 500,
        allowTouchMove: true,
        navigation:
          nextBtn && prevBtn
            ? {
                nextEl: nextBtn,
                prevEl: prevBtn,
                disabledClass: "swiper-button-disabled",
              }
            : false,
      });
    };

    const setupSliderLifecycle = (mainEl) => {
      if (!mainEl) return;

      const state =
        sliderState.get(mainEl) || {
          swiper: null,
          currentLayout: null,
          resizeObserver: null,
          mutationObserver: null,
        };
      sliderState.set(mainEl, state);

      if (!state.resizeObserver) {
        state.resizeObserver = new ResizeObserver((entries) => {
          const [entry] = entries;
          const isMobile = entry.contentRect.width < 576;
          const wantsSlider = mainEl.dataset.layoutMobile === "slider";
          const nextLayout = isMobile && wantsSlider ? "slider" : "grid";

          if (nextLayout === state.currentLayout) return;
          state.currentLayout = nextLayout;

          destroySlider(mainEl);
          if (nextLayout === "slider") initSlider(mainEl);
        });

        state.resizeObserver.observe(mainEl);
      }

      const grid = mainEl.querySelector("#ProductGridContainer");
      if (grid && !state.mutationObserver) {
        let raf = 0;
        state.mutationObserver = new MutationObserver(() => {
          if (raf) cancelAnimationFrame(raf);
          raf = requestAnimationFrame(() => {
            if (state.currentLayout === "slider") {
              initSlider(mainEl);
            }
          });
        });
        state.mutationObserver.observe(grid, { childList: true, subtree: true });
      }
    };

    const initMainCollection = (root) => {
      const sectionEl =
        getMainEl(root);

      if (!sectionEl) return;

      const menu = sectionEl.querySelector(".main-collection__menu");
      if (!menu) return;

      const activeLink = menu.querySelector(".main-collection__menu-link.is-active");

      if (!activeLink) return;

      const behavior = prefersReducedMotion() ? "auto" : "smooth";
      try {
        activeLink.scrollIntoView({ block: "nearest", inline: "center", behavior });
      } catch (e) {
        activeLink.scrollIntoView();
      }

      setupSliderLifecycle(sectionEl);
    };

    for (const el of document.querySelectorAll("[data-main-collection]")) {
      initMainCollection(el);
    }

    document.addEventListener("shopify:section:load", function (event) {
      initMainCollection(event.target);
    });

    document.addEventListener("shopify:section:select", function (event) {
      initMainCollection(event.target);
    });

    document.addEventListener("shopify:section:unload", function () {});
    document.addEventListener("shopify:section:deselect", function () {});
    document.addEventListener("shopify:block:select", function () {});
    document.addEventListener("shopify:block:deselect", function () {});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shpflt-blog-stories"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SELECTOR = '[data-shpflt-blog-stories]';
    const STORE_KEY = '__shpfltBlogStories';

    const getStore = () => {
      if (!window[STORE_KEY]) window[STORE_KEY] = new Map();
      return window[STORE_KEY];
    };

    function initSlider(container, state) {
      if (!container || state.swiperInstance) return;

      container.classList.add('swiper');
      const wrapper = container.querySelector('.shpflt-blog-stories__grid');
      if (!wrapper) return;

      wrapper.classList.add('swiper-wrapper');
      const slides = container.querySelectorAll('.shpflt-blog-stories__card');
      if (!slides.length) return;

      for (const slide of slides) {
        slide.classList.add('swiper-slide');
      }

      const isOverflow = container.classList.contains('shpflt-blog-stories__slider--overflow');
      const spaceBetween = isOverflow ? 16 : 20;
      const slidesPerView = isOverflow ? 'auto' : 1;

      const prevBtn = container.querySelector('[data-shpflt-slider-nav="prev"]');
      const nextBtn = container.querySelector('[data-shpflt-slider-nav="next"]');

      state.swiperInstance = new Swiper(container, {
        loop: false,
        slidesPerView: slidesPerView,
        spaceBetween: spaceBetween,
        speed: 1000,
        navigation: prevBtn && nextBtn ? {
          nextEl: nextBtn,
          prevEl: prevBtn,
          disabledClass: 'shpflt-slider-controls__button--disabled',
        } : false,
      });
    }

    function destroySlider(container, state) {
      if (!container || !state.swiperInstance) return;

      container.classList.remove('swiper');
      const wrapper = container.querySelector('.shpflt-blog-stories__grid');
      const slides = container.querySelectorAll('.shpflt-blog-stories__card');

      if (wrapper) wrapper.classList.remove('swiper-wrapper');
      for (const slide of slides) {
        slide.removeAttribute('style');
        slide.classList.remove('swiper-slide');
      }

      state.swiperInstance.destroy(true, true);
      state.swiperInstance = null;
    }

    function initSection(sectionEl) {
      if (!sectionEl) return;
      const sectionId = sectionEl.getAttribute('data-section-id');
      const store = getStore();
      if (store.has(sectionId)) return;

      const state = {
        swiperInstance: null,
        resizeObserver: null,
        scrollTriggerInstances: [],
      };

      const sliderContainer = sectionEl.querySelector('.shpflt-blog-stories__slider');
      if (sliderContainer) {
        state.resizeObserver = new ResizeObserver((entries) => {
          for (const entry of entries) {
            if (entry.contentRect.width < 750 && !state.swiperInstance) {
              initSlider(sliderContainer, state);
            } else if (entry.contentRect.width >= 750 && state.swiperInstance) {
              destroySlider(sliderContainer, state);
            }
          }
        });
        state.resizeObserver.observe(sectionEl);
      }

      if (sectionEl.classList.contains('shpflt-blog-stories--animate')) {
        const container = sectionEl.querySelector('.shpflt-blog-stories__container');
        if (container && typeof ScrollTrigger !== 'undefined') {
          ScrollTrigger.matchMedia({
            '(max-width: 749px)': function () {
              const st = ScrollTrigger.create({
                trigger: container,
                start: 'top 95%',
                end: 'bottom top',
                onEnter: () => container.classList.add('animated'),
              });
              state.scrollTriggerInstances.push(st);
            },
            '(min-width: 750px)': function () {
              const st = ScrollTrigger.create({
                trigger: container,
                start: 'top 90%',
                end: 'bottom top',
                onEnter: () => container.classList.add('animated'),
              });
              state.scrollTriggerInstances.push(st);
            },
          });
        }
      }

      store.set(sectionId, { destroy: () => destroySection(sectionId) });
    }

    function destroySection(sectionId) {
      const store = getStore();
      const entry = store.get(sectionId);
      if (!entry) return;

      const sectionEl = document.querySelector(`${SELECTOR}[data-section-id="${sectionId}"]`);
      if (sectionEl) {
        const sliderContainer = sectionEl.querySelector('.shpflt-blog-stories__slider');
        if (sliderContainer) destroySlider(sliderContainer, entry);
      }

      if (entry.resizeObserver) {
        entry.resizeObserver.disconnect();
      }

      if (entry.scrollTriggerInstances) {
        for (const st of entry.scrollTriggerInstances) {
          st.kill();
        }
      }

      store.delete(sectionId);
    }

    const boot = () => {
      document.querySelectorAll(SELECTOR).forEach((el) => initSection(el));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const sectionId = event.detail && event.detail.sectionId;
      if (!sectionId) return;
      const el = document.querySelector(`${SELECTOR}[data-section-id="${sectionId}"]`);
      initSection(el);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const sectionId = event.detail && event.detail.sectionId;
      if (!sectionId) return;
      destroySection(sectionId);
    });

    document.addEventListener('shopify:section:select', (event) => {
      const sectionId = event.detail && event.detail.sectionId;
      if (!sectionId) return;
      const el = document.querySelector(`${SELECTOR}[data-section-id="${sectionId}"]`);
      if (el) {
        const container = el.querySelector('.shpflt-blog-stories__container');
        if (container) container.classList.add('animated');
      }
    });

    document.addEventListener('shopify:section:deselect', (event) => {
      const sectionId = event.detail && event.detail.sectionId;
      if (!sectionId) return;
      const el = document.querySelector(`${SELECTOR}[data-section-id="${sectionId}"]`);
      if (el) {
        const container = el.querySelector('.shpflt-blog-stories__container');
        if (container) container.classList.remove('animated');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shpflt-core-values"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const STORE_KEY = '__shpfltCoreValues';

    const getStore = () => {
      if (!window[STORE_KEY]) window[STORE_KEY] = new Map();
      return window[STORE_KEY];
    };

    const initSection = (sectionEl) => {
      if (!sectionEl) return;
      const sectionId = sectionEl.getAttribute('data-section-id');
      const store = getStore();
      if (store.has(sectionId)) return;

      const track = sectionEl.querySelector('[data-shpflt-cv-track]');
      const slides = Array.from(sectionEl.querySelectorAll('[data-shpflt-cv-slide]'));
      const total = slides.length;
      const prevButtons = sectionEl.querySelectorAll('[data-shpflt-slider-nav="prev"]');
      const nextButtons = sectionEl.querySelectorAll('[data-shpflt-slider-nav="next"]');

      if (total === 0 || !track) {
        store.set(sectionId, { destroy: () => store.delete(sectionId) });
        return;
      }

      const updateNavButtons = () => {
        const scrollWidth = track.scrollWidth - track.clientWidth;
        const atStart = track.scrollLeft <= 1;
        const atEnd = scrollWidth <= 0 || track.scrollLeft >= scrollWidth - 1;
        prevButtons.forEach(btn => {
          btn.setAttribute('aria-disabled', atStart ? 'true' : 'false');
          btn.disabled = atStart;
        });
        nextButtons.forEach(btn => {
          btn.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
          btn.disabled = atEnd;
        });
      };

      const cleanups = [];
      track.addEventListener('scroll', updateNavButtons, { passive: true });
      cleanups.push(() => track.removeEventListener('scroll', updateNavButtons));

      // Run after layout so scrollWidth is accurate
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          updateNavButtons();
        });
      });

      // Also re-check after images load (they affect scrollWidth)
      const images = track.querySelectorAll('img');
      if (images.length) {
        let pending = images.length;
        const onLoad = () => { if (--pending <= 0) updateNavButtons(); };
        images.forEach((img) => {
          if (img.complete) { onLoad(); } else { img.addEventListener('load', onLoad, { once: true }); }
        });
      }

      window.addEventListener('resize', updateNavButtons, { passive: true });
      cleanups.push(() => window.removeEventListener('resize', updateNavButtons));

      const onPrev = () => {
        const slideWidth = track.clientWidth;
        track.scrollTo({ left: Math.max(0, track.scrollLeft - slideWidth), behavior: 'smooth' });
      };
      const onNext = () => {
        const slideWidth = track.clientWidth;
        const maxScroll = track.scrollWidth - track.clientWidth;
        track.scrollTo({ left: Math.min(maxScroll, track.scrollLeft + slideWidth), behavior: 'smooth' });
      };
      prevButtons.forEach(btn => {
        btn.addEventListener('click', onPrev);
        cleanups.push(() => btn.removeEventListener('click', onPrev));
      });
      nextButtons.forEach(btn => {
        btn.addEventListener('click', onNext);
        cleanups.push(() => btn.removeEventListener('click', onNext));
      });

      const destroy = () => {
        cleanups.forEach((f) => f());
        store.delete(sectionId);
      };

      store.set(sectionId, {
        destroy,
        scrollToBlock: (blockId) => {
          const card = sectionEl.querySelector(`[data-block-id="${blockId}"]`);
          if (card && card.scrollIntoView) {
            card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        },
      });
    };

    const destroySection = (sectionId) => {
      const store = getStore();
      const entry = store.get(sectionId);
      if (entry && entry.destroy) entry.destroy();
    };

    const boot = () => {
      document.querySelectorAll('[data-shpflt-core-values]').forEach((el) => initSection(el));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const sectionId = event.detail && event.detail.sectionId;
      if (!sectionId) return;
      const el = document.querySelector(`[data-shpflt-core-values][data-section-id="${sectionId}"]`);
      initSection(el);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const sectionId = event.detail && event.detail.sectionId;
      if (!sectionId) return;
      destroySection(sectionId);
    });

    document.addEventListener('shopify:section:select', () => {});

    document.addEventListener('shopify:section:deselect', () => {});

    document.addEventListener('shopify:block:select', (event) => {
      const sectionId = event.detail && event.detail.sectionId;
      const blockId = event.detail && event.detail.blockId;
      if (!sectionId || !blockId) return;
      const store = getStore();
      const entry = store.get(sectionId);
      if (entry && entry.scrollToBlock) entry.scrollToBlock(blockId);
    });

    document.addEventListener('shopify:block:deselect', () => {});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shpflt-footer"] && !Shopify.designMode) return;
  try {
    
(function() {
  const initSection = (sectionElement) => {
    if (!sectionElement) return;
    
    const newsletterForm = sectionElement.querySelector('.shpflt-footer__newsletter-form');
    if (newsletterForm) {
      const emailInput = newsletterForm.querySelector('.shpflt-footer__newsletter-input');
      const consentCheckbox = newsletterForm.querySelector('.shpflt-footer__newsletter-checkbox');
      
      if (emailInput) {
        emailInput.addEventListener('invalid', function(event) {
          this.setAttribute('aria-invalid', 'true');
        });

        emailInput.addEventListener('input', function() {
          if (this.validity.valid) {
            this.removeAttribute('aria-invalid');
          }
        });
      }

      if (consentCheckbox) {
        consentCheckbox.addEventListener('invalid', function(event) {
          event.preventDefault();
          this.classList.add('is-invalid');
        });

        consentCheckbox.addEventListener('change', function() {
          if (this.checked) {
            this.classList.remove('is-invalid');
          }
        });
      }
    }
  };

  const section = document.currentScript?.parentElement;
  if (section) {
    initSection(section);
  }

  document.addEventListener('shopify:section:load', function(event) {
    const sectionElement = event.target.querySelector('.shpflt-footer');
    if (sectionElement) {
      initSection(sectionElement);
    }
  });

  document.addEventListener('shopify:section:unload', function(event) {
    // Cleanup if needed
  });

  document.addEventListener('shopify:block:select', function(event) {
    const sectionElement = event.target.querySelector('.shpflt-footer');
    if (sectionElement) {
      const block = sectionElement.querySelector(`[data-block-id="${event.detail.blockId}"]`);
      if (block) {
        block.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shpflt-header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.headerCoords = {};
      this.calcHeaderCoords();

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
      };

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    calcHeaderCoords() {
      const clientRect = this.getBoundingClientRect();
      const pageYOffset = window.pageYOffset || document.documentElement.scrollTop;
      this.headerCoords.bottom = pageYOffset + clientRect.bottom;
      this.headerCoords.top = pageYOffset + clientRect.top;
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.headerIsAlwaysSticky) {
        if (scrollTop > this.header.offsetHeight + 1) {
          this.header.classList.add('shopify-section-header-sticky');
          if (this.header.classList.contains('color-background-overlay')) {
            this.header.classList.remove('color-background-overlay');
            this.header.classList.add('color-background-overlay-hidden');
          }
        }
        if (scrollTop < this.header.offsetHeight) {
          this.header.classList.remove('shopify-section-header-sticky');
          if (this.header.classList.contains('color-background-overlay-hidden')) {
            this.header.classList.add('color-background-overlay');
            this.header.classList.remove('color-background-overlay-hidden');
          }
        }
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerCoords.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeMegaMenus();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      if (this.header.classList.contains('color-background-overlay')) {
        this.header.classList.remove('color-background-overlay');
        this.header.classList.add('color-background-overlay-hidden');
      }
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      if (this.header.classList.contains('color-background-overlay-hidden')) {
        const openMegas = Array.from(document.querySelectorAll('.shpflt-mega-menu--open'));
        if (openMegas.length > 0) return;
        this.header.classList.add('color-background-overlay');
        this.header.classList.remove('color-background-overlay-hidden');
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      if (customElements.get('details-disclosure')) {
        this.disclosures.forEach((disclosure) => disclosure.close());
      }
      this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
      this.disclosureLists.forEach((list) => list.setAttribute('hidden', true));
    }

    closeMegaMenus() {
      const openMegas = this.header.querySelectorAll('.shpflt-mega-menu--open');
      openMegas.forEach((mega) => mega.classList.remove('shpflt-mega-menu--open'));
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  /* ── Header height & mega menu hover ── */
  (function () {
    const initShpfltHeader = () => {
      const section = document.querySelector('.shopify-section-header');
      if (!section) return;

      const header = section.querySelector('.shpflt-header');
      if (!header) return;

      /* ── Header height CSS variable ── */
      const updateHeight = () => {
        const h = section.getBoundingClientRect().height.toFixed(2);
        document.documentElement.style.setProperty('--header-height', h + 'px');
      };
      const headerObserver = new ResizeObserver(updateHeight);
      headerObserver.observe(section);

      /* ── Desktop mega menu hover logic ── */
      const megaItems = header.querySelectorAll('.shpflt-header__menu-item--has-mega');
      if (!megaItems.length) return;

      megaItems.forEach((item) => {
        const megaPanel = item.querySelector('.shpflt-mega-menu');
        if (!megaPanel) return;

        const trigger = item.querySelector('.shpflt-header__link');
        if (!trigger) return;

        /* Calculate left offset so the mega menu spans the full viewport */
        const updateOffset = () => {
          const rect = item.getBoundingClientRect();
          const offset = -1 * rect.left;
          megaPanel.style.setProperty('--shpflt-mega-menu-offset', offset + 'px');
        };

        let closeTimeout = null;

        const cancelClose = () => {
          clearTimeout(closeTimeout);
          closeTimeout = null;
        };

        const openMega = () => {
          cancelClose();
          updateOffset();

          /* Close other open mega menus instantly */
          megaItems.forEach((other) => {
            if (other !== item) {
              const otherPanel = other.querySelector('.shpflt-mega-menu');
              const otherTrigger = other.querySelector('.shpflt-header__link');
              if (otherPanel) {
                otherPanel.classList.remove('shpflt-mega-menu--open');
                if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
              }
            }
          });

          megaPanel.classList.add('shpflt-mega-menu--open');
          trigger.setAttribute('aria-expanded', 'true');
          section.classList.add('header-sticky-with-opened-mega-menu');

          /* Close any open disclosure lists */
          const disclosures = header.querySelectorAll('details-disclosure');
          if (customElements.get('details-disclosure')) {
            disclosures.forEach((d) => d.close());
          }
        };

        const closeMega = () => {
          cancelClose();
          closeTimeout = setTimeout(() => {
            megaPanel.classList.remove('shpflt-mega-menu--open');
            trigger.setAttribute('aria-expanded', 'false');
            const anyOpen = header.querySelector('.shpflt-mega-menu--open');
            if (!anyOpen) {
              section.classList.remove('header-sticky-with-opened-mega-menu');
            }
            closeTimeout = null;
          }, 250);
        };

        item.addEventListener('mouseenter', openMega);
        item.addEventListener('mouseleave', closeMega);
        megaPanel.addEventListener('mouseenter', cancelClose);
        megaPanel.addEventListener('mouseleave', closeMega);

        /* Focus-based open/close for keyboard accessibility */
        item.addEventListener('focusin', openMega);
        item.addEventListener('focusout', (e) => {
          /* Only close if focus is moving outside the menu item (which contains the panel) */
          /* Skip if relatedTarget is null (focus moved to browser chrome or another window) */
          if (e.relatedTarget && !item.contains(e.relatedTarget)) {
            closeMega();
          }
        });

        /* Close on overlay hover */
        const overlay = megaPanel.querySelector('.shpflt-mega-menu__overlay');
        if (overlay) {
          overlay.addEventListener('mouseenter', () => {
            megaPanel.classList.remove('shpflt-mega-menu--open');
            trigger.setAttribute('aria-expanded', 'false');
            section.classList.remove('header-sticky-with-opened-mega-menu');
          });
        }

        /* Keyboard: close on Escape */
        megaPanel.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') {
            megaPanel.classList.remove('shpflt-mega-menu--open');
            trigger.setAttribute('aria-expanded', 'false');
            section.classList.remove('header-sticky-with-opened-mega-menu');
            trigger.focus();
          }
        });
      });

      /* Nav-level close is handled by per-item mouseleave + overlay mouseenter.
         A nav.mouseleave listener would fire when the cursor moves into the
         absolutely-positioned mega panel (which overflows the nav box),
         causing premature closure. */

      /* ── Submenu positioning for non-mega dropdown items ── */
      header.querySelectorAll('.shpflt-header__menu-item--has-dropdown').forEach((item) => {
        item.addEventListener('mouseenter', () => {
          item.querySelectorAll('.header__submenu .header__submenu').forEach((submenu) => {
            submenu.style.setProperty('--clientY', submenu.getBoundingClientRect().top + 'px');
          });
        });
      });
    };

    initShpfltHeader();

    document.addEventListener('shopify:section:load', initShpfltHeader);
    document.addEventListener('shopify:section:unload', initShpfltHeader);
    document.addEventListener('shopify:section:reorder', initShpfltHeader);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shpflt-intro-statement"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-smooth-scroll]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var href = this.getAttribute('href');
      if (href && href.startsWith('#')) {
        var target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth' });
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shpflt-key-differences-grid"] && !Shopify.designMode) return;
  try {
    
  (function() {
    'use strict';

    function initKeyDifferencesGrid(sectionElement) {
      const sectionId = sectionElement.dataset.kdgSection;
      if (!sectionId) return;

      const tabs = sectionElement.querySelectorAll('[data-kdg-tab]');
      const panels = sectionElement.querySelectorAll('[data-kdg-panel]');

      if (tabs.length === 0 || panels.length === 0) return;

      function switchTab(activeTab) {
        const tabId = activeTab.dataset.kdgTab;
        if (!tabId) return;

        // Update tabs
        tabs.forEach(tab => {
          const isActive = tab.dataset.kdgTab === tabId;
          tab.classList.toggle('active', isActive);
          tab.setAttribute('aria-selected', isActive);
          tab.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        // Update panels
        panels.forEach(panel => {
          const isActive = panel.dataset.kdgPanel === tabId;
          panel.classList.toggle('active', isActive);
          if (isActive) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        });
      }

      // Tab click handlers
      tabs.forEach(tab => {
        tab.addEventListener('click', function(e) {
          e.preventDefault();
          switchTab(this);
        });

        // Keyboard navigation
        tab.addEventListener('keydown', function(e) {
          const currentIndex = Array.from(tabs).indexOf(this);
          let targetIndex = currentIndex;

          switch(e.key) {
            case 'ArrowRight':
              e.preventDefault();
              targetIndex = (currentIndex + 1) % tabs.length;
              break;
            case 'ArrowLeft':
              e.preventDefault();
              targetIndex = (currentIndex - 1 + tabs.length) % tabs.length;
              break;
            case 'Home':
              e.preventDefault();
              targetIndex = 0;
              break;
            case 'End':
              e.preventDefault();
              targetIndex = tabs.length - 1;
              break;
            case 'Enter':
            case ' ':
              e.preventDefault();
              switchTab(this);
              return;
            default:
              return;
          }

          if (targetIndex !== currentIndex) {
            tabs[targetIndex].focus();
            switchTab(tabs[targetIndex]);
          }
        });
      });
    }

    // Initialize on page load
    document.querySelectorAll('[data-kdg-section]').forEach(section => {
      initKeyDifferencesGrid(section);
    });

    // Theme Editor events
    document.addEventListener('shopify:section:load', function(event) {
      const sectionElement = event.target.querySelector('[data-kdg-section]');
      if (sectionElement) {
        initKeyDifferencesGrid(sectionElement);
      }
    });

    document.addEventListener('shopify:section:unload', function(event) {
      const sectionId = event.detail?.sectionId;
      if (!sectionId) return;
      // Section DOM is removed by Shopify; no persistent state to clean up.
    });

    document.addEventListener('shopify:section:select', function(event) {
      const sectionId = event.detail?.sectionId;
      if (!sectionId) return;
      const sectionElement = document.querySelector(`[data-kdg-section="${sectionId}"]`);
      if (sectionElement) {
        const tablist = sectionElement.querySelector('[role="tablist"]');
        if (tablist && tablist.focus) tablist.focus({ preventScroll: true });
      }
    });

    document.addEventListener('shopify:section:deselect', function() {});

    document.addEventListener('shopify:block:select', function(event) {
      const sectionElement = event.target.closest('[data-kdg-section]');
      if (!sectionElement) return;

      const blockId = event.detail.blockId;
      const tab = sectionElement.querySelector(`[data-kdg-tab="${blockId}"]`);
      if (tab) {
        const tabs = sectionElement.querySelectorAll('[data-kdg-tab]');
        const currentIndex = Array.from(tabs).indexOf(tab);
        tabs.forEach((t, i) => {
          const isActive = i === currentIndex;
          t.classList.toggle('active', isActive);
          t.setAttribute('aria-selected', isActive);
          t.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        const panels = sectionElement.querySelectorAll('[data-kdg-panel]');
        panels.forEach(panel => {
          const isActive = panel.dataset.kdgPanel === blockId;
          panel.classList.toggle('active', isActive);
          if (isActive) {
            panel.removeAttribute('hidden');
            panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          } else {
            panel.setAttribute('hidden', '');
          }
        });
      }
    });

    document.addEventListener('shopify:block:deselect', function() {});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shpflt-main-product"] && !Shopify.designMode) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shpflt-multi-column-image-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initSection = (sectionEl) => {
      if (!sectionEl) return;
    };

    const destroySection = (sectionId) => {};

    const boot = () => {
      document
        .querySelectorAll('[data-shpflt-multi-column-image-grid]')
        .forEach((el) => initSection(el));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const sectionId = event.detail && event.detail.sectionId;
      if (!sectionId) return;
      const el = document.querySelector(`[data-shpflt-multi-column-image-grid][data-section-id="${sectionId}"]`);
      initSection(el);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const sectionId = event.detail && event.detail.sectionId;
      if (!sectionId) return;
      destroySection(sectionId);
    });

    document.addEventListener('shopify:section:select', (event) => {
      const sectionId = event.detail && event.detail.sectionId;
      if (!sectionId) return;
    });

    document.addEventListener('shopify:section:deselect', (event) => {
      const sectionId = event.detail && event.detail.sectionId;
      if (!sectionId) return;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shpflt-our-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const instances = (window.__shpfltOurStoryInstances = window.__shpfltOurStoryInstances || new Map());

    function loadScript(url) {
      return new Promise((resolve, reject) => {
        const existing = document.querySelector(`script[src="${url}"]`);
        if (existing) { resolve(); return; }
        const s = document.createElement('script');
        s.src = url;
        s.onload = resolve;
        s.onerror = reject;
        document.head.appendChild(s);
      });
    }

    async function loadDeps(root) {
      const jqueryUrl = root.dataset.jqueryUrl;
      const turnUrl = root.dataset.turnUrl;
      if (!window.jQuery) await loadScript(jqueryUrl);
      if (!window.jQuery.fn.turn) await loadScript(turnUrl);
    }

    function clamp(n, min, max) {
      return Math.max(min, Math.min(max, n));
    }

    function getDuration(root) {
      const raw = root.dataset.animationDuration || '700';
      const ms = parseInt(raw, 10);
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      return reduced ? 1 : (Number.isFinite(ms) ? clamp(ms, 300, 1500) : 700);
    }

    async function init(root) {
      if (!root || instances.has(root)) return;

      const flipbookEl = root.querySelector('[data-shpflt-os-flipbook]');
      const metaEl = root.querySelector('[data-shpflt-os-meta]');
      const prevBtn = root.querySelector('[data-shpflt-os-prev]');
      const nextBtn = root.querySelector('[data-shpflt-os-next]');
      const stage = root.querySelector('[data-shpflt-os-stage]');

      if (!flipbookEl || !stage) return;

      const totalPages = flipbookEl.querySelectorAll('.shpflt-os__turnpage').length;
      if (totalPages === 0) return;

      await loadDeps(root);

      const $ = window.jQuery;
      const $flipbook = $(flipbookEl);

      function isMobileWidth() {
        return stage.getBoundingClientRect().width < 720;
      }

      function getDisplayMode() {
        return isMobileWidth() ? 'single' : 'double';
      }

      function computeDimensions() {
        const stageW = stage.getBoundingClientRect().width;
        const mobile = stageW < 720;
        const w = stageW;
        const h = mobile ? Math.round(w * 1.25) : Math.round(w * (11 / 16));
        return { width: w, height: h };
      }

      /* If odd number of pages, add a blank for even double-page spreads */
      if (totalPages % 2 !== 0) {
        const blank = document.createElement('div');
        blank.className = 'shpflt-os__turnpage';
        blank.style.background = 'rgb(var(--color-background))';
        flipbookEl.appendChild(blank);
      }

      const dims = computeDimensions();
      const duration = getDuration(root);

      $flipbook.turn({
        width: dims.width,
        height: dims.height,
        autoCenter: true,
        display: getDisplayMode(),
        duration: duration,
        acceleration: true,
        elevation: 50,
        gradients: true,
        when: {
          turning: function(event, page, view) {
            updateMeta(page);
            updateButtons(page);
            updateSpineShadow(page);
          },
          turned: function(event, page, view) {
            updateMeta(page);
            updateButtons(page);
            updateSpineShadow(page);
          }
        }
      });

      function updateMeta(page) {
        if (!metaEl) return;
        const total = $flipbook.turn('pages');
        const singleTpl = metaEl.dataset.labelSingle || '[c] / [t]';
        const spreadTpl = metaEl.dataset.labelSpread || '[c] / [t]';
        const display = $flipbook.turn('display');

        if (display === 'single') {
          const label = singleTpl.replace('[c]', page).replace('[t]', total);
          metaEl.textContent = label;
        } else {
          const view = $flipbook.turn('view');
          const left = view[0] || 1;
          const right = view[1] || total;
          const current = left + '–' + right;
          const label = spreadTpl.replace('[c]', current).replace('[t]', total);
          metaEl.textContent = label;
        }
      }

      function updateButtons(page) {
        const total = $flipbook.turn('pages');
        if (prevBtn) prevBtn.disabled = (page <= 1);
        if (nextBtn) nextBtn.disabled = (page >= total);
      }

      function updateSpineShadow(page) {
        const display = $flipbook.turn('display');
        const total = $flipbook.turn('pages');
        const isOpen = display === 'double' && page > 1 && page < total;
        flipbookEl.classList.toggle('shpflt-os__flipbook--open', isOpen);
      }

      function goPrev() {
        $flipbook.turn('previous');
      }

      function goNext() {
        $flipbook.turn('next');
      }

      function onKeydown(e) {
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          goNext();
        }
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          goPrev();
        }
      }

      if (prevBtn) prevBtn.addEventListener('click', goPrev);
      if (nextBtn) nextBtn.addEventListener('click', goNext);
      stage.addEventListener('keydown', onKeydown);

      /* Initial state */
      updateMeta(1);
      updateButtons(1);
      root.classList.add('shpflt-os--ready');

      /* Responsive resize */
      let currentDisplay = getDisplayMode();
      const ro = new ResizeObserver(() => {
        const newDisplay = getDisplayMode();
        const newDims = computeDimensions();

        if (newDisplay !== currentDisplay) {
          $flipbook.turn('display', newDisplay);
          currentDisplay = newDisplay;
        }
        $flipbook.turn('size', newDims.width, newDims.height);

        const page = $flipbook.turn('page');
        updateMeta(page);
        updateButtons(page);
      });
      ro.observe(stage);

      instances.set(root, {
        destroy() {
          ro.disconnect();
          if (prevBtn) prevBtn.removeEventListener('click', goPrev);
          if (nextBtn) nextBtn.removeEventListener('click', goNext);
          stage.removeEventListener('keydown', onKeydown);
          $flipbook.turn('destroy');
          instances.delete(root);
        },
        setPageByBlockId(blockId) {
          const pages = flipbookEl.querySelectorAll('.shpflt-os__turnpage[data-block-id]');
          let pageNum = -1;
          pages.forEach((p, i) => {
            if (String(p.dataset.blockId) === String(blockId)) {
              pageNum = i + 1;
            }
          });
          if (pageNum > 0) {
            $flipbook.turn('page', pageNum);
          }
        }
      });
    }

    function destroyBySectionId(sectionId) {
      const el = document.querySelector(`[data-shpflt-our-story][data-section-id="${sectionId}"]`);
      if (!el) return;
      const inst = instances.get(el);
      if (inst && inst.destroy) inst.destroy();
    }

    function initAll() {
      document.querySelectorAll('[data-shpflt-our-story]').forEach((el) => init(el));
    }

    document.addEventListener('shopify:section:load', (e) => {
      const sectionId = e.detail && e.detail.sectionId;
      if (!sectionId) return;
      const el = document.querySelector(`[data-shpflt-our-story][data-section-id="${sectionId}"]`);
      if (el) init(el);
    });

    document.addEventListener('shopify:section:unload', (e) => {
      const sectionId = e.detail && e.detail.sectionId;
      if (sectionId) destroyBySectionId(sectionId);
    });

    document.addEventListener('shopify:section:select', (e) => {
      const sectionId = e.detail && e.detail.sectionId;
      if (!sectionId) return;
      const el = document.querySelector(`[data-shpflt-our-story][data-section-id="${sectionId}"]`);
      if (!el) return;
      const stage = el.querySelector('[data-shpflt-os-stage]');
      if (stage && stage.focus) stage.focus({ preventScroll: true });
    });

    document.addEventListener('shopify:block:select', (e) => {
      const { sectionId, blockId } = e.detail || {};
      if (!sectionId || !blockId) return;
      const el = document.querySelector(`[data-shpflt-our-story][data-section-id="${sectionId}"]`);
      if (!el) return;
      const inst = instances.get(el);
      if (inst && inst.setPageByBlockId) inst.setPageByBlockId(blockId);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shpflt-product-breakdown"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SELECTOR = '[data-shpflt-product-breakdown]';

    const initSection = (root) => {
      const cleanups = [];

      const columns = root.querySelector('.shpflt-pb__columns');
      const allColumnEls = Array.from(root.querySelectorAll('[data-shpflt-pb-column]'));
      const switchButton = root.querySelector('.shpflt-pb__switch');
      const prevButton = root.querySelector('[data-shpflt-slider-nav="prev"]');
      const nextButton = root.querySelector('[data-shpflt-slider-nav="next"]');
      const allDots = Array.from(root.querySelectorAll('[data-shpflt-pb-dot]'));

      if (!(columns instanceof HTMLElement)) return () => {};
      if (!(switchButton instanceof HTMLButtonElement)) return () => {};

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const allowedSchemeClass = root.dataset.colorSchemeAllowed || '';
      const blockedSchemeClass = root.dataset.colorSchemeBlocked || '';
      const transition = root.dataset.transition || 'fade';
      const duration = Number.parseInt(root.style.getPropertyValue('--shpflt-pb-transition-duration') || '260', 10) || 260;

      const getCurrentView = () => root.dataset.view === 'blocked' ? 'blocked' : 'allowed';
      const getVisibleColumns = () => allColumnEls.filter(c => c.dataset.view === getCurrentView());
      const getVisibleDots = () => allDots.filter(d => d.dataset.view === getCurrentView());

      const timeouts = [];
      const trackTimeout = (id) => timeouts.push(id);
      const clearTimeouts = () => {
        for (const id of timeouts) window.clearTimeout(id);
        timeouts.length = 0;
      };

      const setActiveIndex = (visibleIndex) => {
        const visible = getVisibleColumns();
        const visibleDots = getVisibleDots();
        const clamped = Math.max(0, Math.min(visibleIndex, visible.length - 1));
        root.dataset.activeIndex = String(clamped);

        for (let i = 0; i < visibleDots.length; i++) {
          visibleDots[i].setAttribute('aria-current', i === clamped ? 'true' : 'false');
        }

        if (prevButton instanceof HTMLButtonElement) {
          const disabled = clamped <= 0;
          prevButton.setAttribute('aria-disabled', disabled ? 'true' : 'false');
          prevButton.disabled = disabled;
        }

        if (nextButton instanceof HTMLButtonElement) {
          const disabled = clamped >= visible.length - 1;
          nextButton.setAttribute('aria-disabled', disabled ? 'true' : 'false');
          nextButton.disabled = disabled;
        }
      };

      const scrollToVisibleIndex = (visibleIndex, options = {}) => {
        const visible = getVisibleColumns();
        const clamped = Math.max(0, Math.min(visibleIndex, visible.length - 1));
        const target = visible[clamped];
        if (!(target instanceof HTMLElement)) return;
        columns.scrollTo({ left: target.offsetLeft, behavior: options.behavior || 'smooth' });
      };

      const resetCarousel = () => {
        columns.scrollTo({ left: 0, behavior: 'instant' });
        setActiveIndex(0);
      };

      const applyView = (v) => {
        root.dataset.view = v;
        switchButton.setAttribute('aria-checked', v === 'blocked' ? 'true' : 'false');
        root.classList.remove(allowedSchemeClass, blockedSchemeClass);
        root.classList.add(v === 'blocked' ? blockedSchemeClass : allowedSchemeClass);
        const titleColor = v === 'blocked'
          ? root.dataset.columnTitleColorBlocked
          : root.dataset.columnTitleColorAllowed;
        if (titleColor) root.style.setProperty('--shpflt-pb-column-title-color', titleColor);
        resetCarousel();
      };

      const setView = (view, options = {}) => {
        const nextView = view === 'blocked' ? 'blocked' : 'allowed';
        if (getCurrentView() === nextView) return;

        if (!options.animate || prefersReducedMotion || transition === 'none' || duration <= 0) {
          clearTimeouts();
          root.dataset.isTransitioning = 'false';
          applyView(nextView);
          return;
        }

        clearTimeouts();
        root.dataset.isTransitioning = 'true';

        const swapAt = Math.max(90, Math.floor(duration * 0.35));
        const endAt = Math.max(180, Math.floor(duration * 0.7));

        trackTimeout(window.setTimeout(() => applyView(nextView), swapAt));
        trackTimeout(window.setTimeout(() => {
          root.dataset.isTransitioning = 'false';
        }, endAt));
      };

      const defaultView = root.dataset.defaultView === 'blocked' ? 'blocked' : 'allowed';
      root.dataset.view = defaultView;
      switchButton.setAttribute('aria-checked', defaultView === 'blocked' ? 'true' : 'false');
      setActiveIndex(0);

      const handleSwitchToggle = () => {
        setView(getCurrentView() === 'blocked' ? 'allowed' : 'blocked', { animate: true });
      };

      switchButton.addEventListener('click', handleSwitchToggle);
      cleanups.push(() => switchButton.removeEventListener('click', handleSwitchToggle));

      if (prevButton instanceof HTMLButtonElement) {
        const onPrev = () => {
          const current = Number.parseInt(root.dataset.activeIndex || '0', 10) || 0;
          scrollToVisibleIndex(current - 1);
        };
        prevButton.addEventListener('click', onPrev);
        cleanups.push(() => prevButton.removeEventListener('click', onPrev));
      }

      if (nextButton instanceof HTMLButtonElement) {
        const onNext = () => {
          const current = Number.parseInt(root.dataset.activeIndex || '0', 10) || 0;
          scrollToVisibleIndex(current + 1);
        };
        nextButton.addEventListener('click', onNext);
        cleanups.push(() => nextButton.removeEventListener('click', onNext));
      }

      for (const dot of allDots) {
        const onDotClick = () => {
          if (dot.dataset.view !== getCurrentView()) return;
          const visibleIndex = getVisibleDots().indexOf(dot);
          if (visibleIndex >= 0) scrollToVisibleIndex(visibleIndex);
        };
        dot.addEventListener('click', onDotClick);
        cleanups.push(() => dot.removeEventListener('click', onDotClick));
      }

      let raf = 0;
      const onScroll = () => {
        if (raf) return;
        raf = window.requestAnimationFrame(() => {
          raf = 0;
          const visible = getVisibleColumns();
          const center = columns.scrollLeft + (columns.clientWidth / 2);
          let bestIndex = 0;
          let bestDistance = Number.POSITIVE_INFINITY;

          for (let i = 0; i < visible.length; i++) {
            const colCenter = visible[i].offsetLeft + (visible[i].clientWidth / 2);
            const dist = Math.abs(colCenter - center);
            if (dist < bestDistance) {
              bestDistance = dist;
              bestIndex = i;
            }
          }

          setActiveIndex(bestIndex);
        });
      };

      columns.addEventListener('scroll', onScroll, { passive: true });
      cleanups.push(() => columns.removeEventListener('scroll', onScroll));
      cleanups.push(() => { if (raf) window.cancelAnimationFrame(raf); });

      return () => {
        clearTimeouts();
        for (const cleanup of cleanups) cleanup();
      };
    };

    /** @type {Map<string, () => void>} */
    const instances = new Map();

    const destroy = (sectionId) => {
      const cleanup = instances.get(sectionId);
      if (typeof cleanup !== 'function') return;
      cleanup();
      instances.delete(sectionId);
    };

    const mount = (root) => {
      const sectionId = root.dataset.sectionId || '';
      if (!sectionId) return;
      destroy(sectionId);
      instances.set(sectionId, initSection(root));
    };

    const mountAll = () => {
      for (const root of document.querySelectorAll(SELECTOR)) {
        if (root instanceof HTMLElement) mount(root);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', mountAll, { once: true });
    } else {
      mountAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const sectionId = event?.detail?.sectionId;
      if (!sectionId) return;
      const root = document.querySelector(`${SELECTOR}[data-section-id="${sectionId}"]`);
      if (root instanceof HTMLElement) mount(root);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const sectionId = event?.detail?.sectionId;
      if (sectionId) destroy(sectionId);
    });

    document.addEventListener('shopify:section:select', (event) => {
      const sectionId = event?.detail?.sectionId;
      if (!sectionId) return;
      const root = document.querySelector(`${SELECTOR}[data-section-id="${sectionId}"]`);
      if (root instanceof HTMLElement) root.dataset.isTransitioning = 'false';
    });

    document.addEventListener('shopify:section:deselect', () => {});

    document.addEventListener('shopify:block:select', (event) => {
      const sectionId = event?.detail?.sectionId;
      const blockId = event?.detail?.blockId;
      if (!sectionId || !blockId) return;
      const root = document.querySelector(`${SELECTOR}[data-section-id="${sectionId}"]`);
      if (!(root instanceof HTMLElement)) return;
      const column = root.querySelector(`[data-block-id="${blockId}"]`);
      if (!column) return;

      const blockView = column.dataset.view || 'allowed';
      const currentView = root.dataset.view === 'blocked' ? 'blocked' : 'allowed';
      if (blockView !== currentView) {
        root.dataset.view = blockView;
        const sw = root.querySelector('.shpflt-pb__switch');
        if (sw) sw.setAttribute('aria-checked', blockView === 'blocked' ? 'true' : 'false');
        const aClass = root.dataset.colorSchemeAllowed || '';
        const bClass = root.dataset.colorSchemeBlocked || '';
        root.classList.remove(aClass, bClass);
        root.classList.add(blockView === 'blocked' ? bClass : aClass);
      }

      column.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });

    document.addEventListener('shopify:block:deselect', () => {});

    // Smooth scroll for CTA links
    document.querySelectorAll('[data-smooth-scroll]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var href = link.getAttribute('href');
        if (href && href.startsWith('#')) {
          var target = document.querySelector(href);
          if (target) {
            e.preventDefault();
            target.scrollIntoView({ behavior: 'smooth' });
          }
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shpflt-showcase-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.shpflt-showcase-carousel-section').forEach(function(section) {
    var track = section.querySelector('.swc__track');
    var allPrevBtns = section.querySelectorAll('[data-shpflt-slider-nav="prev"]');
    var allNextBtns = section.querySelectorAll('[data-shpflt-slider-nav="next"]');
    if (!track || (!allPrevBtns.length && !allNextBtns.length)) return;

    var cards = track.querySelectorAll('.swc__card');
    var currentIndex = 0;

    function getCurrentIndex() {
      var trackLeft = track.scrollLeft;
      var closest = 0;
      var closestDist = Infinity;
      cards.forEach(function(card, i) {
        var dist = Math.abs(card.offsetLeft - track.offsetLeft - trackLeft);
        if (dist < closestDist) { closestDist = dist; closest = i; }
      });
      return closest;
    }

    function updateArrows() {
      currentIndex = getCurrentIndex();
      allPrevBtns.forEach(function(btn) {
        btn.disabled = currentIndex <= 0;
        btn.setAttribute('aria-disabled', currentIndex <= 0 ? 'true' : 'false');
      });
      allNextBtns.forEach(function(btn) {
        btn.disabled = currentIndex >= cards.length - 1;
        btn.setAttribute('aria-disabled', currentIndex >= cards.length - 1 ? 'true' : 'false');
      });
    }

    function scrollToCard(index) {
      if (index < 0 || index >= cards.length) return;
      currentIndex = index;
      cards[currentIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      setTimeout(updateArrows, 400);
    }

    track.addEventListener('scroll', function() { clearTimeout(track._scrollTimer); track._scrollTimer = setTimeout(updateArrows, 150); }, { passive: true });
    allPrevBtns.forEach(function(btn) { btn.addEventListener('click', function() { scrollToCard(currentIndex - 1); }); });
    allNextBtns.forEach(function(btn) { btn.addEventListener('click', function() { scrollToCard(currentIndex + 1); }); });
    updateArrows();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shpflt-testimonials-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const STORE_KEY = '__shpfltTestimonialsShowcase';

    const getStore = () => {
      if (!window[STORE_KEY]) window[STORE_KEY] = new Map();
      return window[STORE_KEY];
    };

    const safePlay = async (video) => {
      try {
        const res = video.play();
        if (res && typeof res.then === 'function') await res;
      } catch (e) {
        // Autoplay might be blocked; ignore.
      }
    };

    const updateButtonState = (btn, isPlaying) => {
      btn.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
      const base = btn.getAttribute('data-label-base') || btn.getAttribute('aria-label') || 'Play video';
      btn.setAttribute('aria-label', isPlaying ? base.replace(/^Play\b/i, 'Pause') : base.replace(/^Pause\b/i, 'Play'));
    };

    const initSection = (sectionEl) => {
      if (!sectionEl) return;
      const sectionId = sectionEl.getAttribute('data-section-id');
      const store = getStore();
      if (store.has(sectionId)) return;

      const track = sectionEl.querySelector('[data-shpflt-ts-track]');
      const slides = Array.from(sectionEl.querySelectorAll('[data-shpflt-ts-slide]'));
      const total = slides.length;
      const prevButton = sectionEl.querySelector('[data-shpflt-slider-nav="prev"]');
      const nextButton = sectionEl.querySelector('[data-shpflt-slider-nav="next"]');

      const updateNavButtons = () => {
        if (!track || total === 0) return;
        const scrollWidth = track.scrollWidth - track.clientWidth;
        const atStart = track.scrollLeft <= 1;
        const atEnd = scrollWidth <= 0 || track.scrollLeft >= scrollWidth - 1;
        if (prevButton) {
          prevButton.setAttribute('aria-disabled', atStart ? 'true' : 'false');
          prevButton.disabled = atStart;
        }
        if (nextButton) {
          nextButton.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
          nextButton.disabled = atEnd;
        }
      };

      const scrollHandlers = [];
      if (track) {
        track.addEventListener('scroll', updateNavButtons, { passive: true });
        scrollHandlers.push(() => track.removeEventListener('scroll', updateNavButtons));
        updateNavButtons();
      }

      if (prevButton && track) {
        const onPrev = () => {
          const slideWidth = track.clientWidth;
          track.scrollTo({ left: Math.max(0, track.scrollLeft - slideWidth), behavior: 'smooth' });
        };
        prevButton.addEventListener('click', onPrev);
        scrollHandlers.push(() => prevButton.removeEventListener('click', onPrev));
      }
      if (nextButton && track) {
        const onNext = () => {
          const slideWidth = track.clientWidth;
          const maxScroll = track.scrollWidth - track.clientWidth;
          track.scrollTo({ left: Math.min(maxScroll, track.scrollLeft + slideWidth), behavior: 'smooth' });
        };
        nextButton.addEventListener('click', onNext);
        scrollHandlers.push(() => nextButton.removeEventListener('click', onNext));
      }

      const autoplayMode = sectionEl.getAttribute('data-autoplay-mode') || 'paused';
      const mediaEls = Array.from(sectionEl.querySelectorAll('.shpflt-ts__media'));

      const handlers = [];

      mediaEls.forEach((mediaEl) => {
        const video = mediaEl.querySelector('video');
        const button = mediaEl.querySelector('.shpflt-ts__media-button');
        if (!button) return;

        const preload = mediaEl.getAttribute('data-preload') || 'metadata';
        const loop = mediaEl.getAttribute('data-loop') === 'true';

        button.setAttribute('data-label-base', button.getAttribute('aria-label') || 'Play video');

        if (video) {
          video.preload = preload;
          video.loop = loop;
          video.playsInline = true;

          // Apply section-level autoplay behavior
          if (autoplayMode === 'autoplay_muted') {
            video.muted = true;
            safePlay(video).then(() => {
              if (!video.paused) {
                mediaEl.classList.add('is-playing');
                updateButtonState(button, true);
              }
            });
          } else {
            // Ensure paused initial state
            video.pause();
            mediaEl.classList.remove('is-playing');
            updateButtonState(button, false);
          }

          const onPlay = () => {
            mediaEl.classList.add('is-playing');
            updateButtonState(button, true);
          };
          const onPause = () => {
            mediaEl.classList.remove('is-playing');
            updateButtonState(button, false);
          };
          video.addEventListener('play', onPlay);
          video.addEventListener('pause', onPause);
          handlers.push(() => video.removeEventListener('play', onPlay));
          handlers.push(() => video.removeEventListener('pause', onPause));
        }

        const onClick = async () => {
          if (!video) return;
          if (video.paused) {
            await safePlay(video);
          } else {
            video.pause();
          }
        };
        button.addEventListener('click', onClick);
        handlers.push(() => button.removeEventListener('click', onClick));
      });

      store.set(sectionId, {
        destroy: () => {
          scrollHandlers.forEach((f) => f());
          handlers.forEach((f) => f());
          store.delete(sectionId);
        },
        scrollToBlock: (blockId) => {
          const item = sectionEl.querySelector(`[data-block-id="${blockId}"]`);
          if (item && item.scrollIntoView) {
            item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        },
        pauseAll: () => {
          mediaEls.forEach((mediaEl) => {
            const v = mediaEl.querySelector('video');
            const btn = mediaEl.querySelector('.shpflt-ts__media-button');
            if (v) v.pause();
            mediaEl.classList.remove('is-playing');
            if (btn) updateButtonState(btn, false);
          });
        },
        resume: () => {
          if (autoplayMode !== 'autoplay_muted') return;
          mediaEls.forEach((mediaEl) => {
            const v = mediaEl.querySelector('video');
            if (v) {
              v.muted = true;
              safePlay(v);
            }
          });
        },
      });
    };

    const destroySection = (sectionId) => {
      const store = getStore();
      const entry = store.get(sectionId);
      if (entry && entry.destroy) entry.destroy();
    };

    const boot = () => {
      document
        .querySelectorAll('[data-shpflt-testimonials-showcase]')
        .forEach((el) => initSection(el));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    // Shopify Theme Editor integration
    document.addEventListener('shopify:section:load', (event) => {
      const sectionId = event.detail && event.detail.sectionId;
      if (!sectionId) return;
      const el = document.querySelector(`[data-shpflt-testimonials-showcase][data-section-id="${sectionId}"]`);
      initSection(el);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const sectionId = event.detail && event.detail.sectionId;
      if (!sectionId) return;
      destroySection(sectionId);
    });

    document.addEventListener('shopify:section:select', (event) => {
      const sectionId = event.detail && event.detail.sectionId;
      if (!sectionId) return;
      const store = getStore();
      const entry = store.get(sectionId);
      if (entry && entry.pauseAll) entry.pauseAll();
    });

    document.addEventListener('shopify:section:deselect', (event) => {
      const sectionId = event.detail && event.detail.sectionId;
      if (!sectionId) return;
      const store = getStore();
      const entry = store.get(sectionId);
      if (entry && entry.resume) entry.resume();
    });

    document.addEventListener('shopify:block:select', (event) => {
      const sectionId = event.detail && event.detail.sectionId;
      const blockId = event.detail && event.detail.blockId;
      if (!sectionId || !blockId) return;
      const store = getStore();
      const entry = store.get(sectionId);
      if (entry && entry.scrollToBlock) {
        entry.scrollToBlock(blockId);
        return;
      }
      const sectionEl = document.querySelector(`[data-shpflt-testimonials-showcase][data-section-id="${sectionId}"]`);
      if (!sectionEl) return;
      const item = sectionEl.querySelector(`[data-block-id="${blockId}"]`);
      if (item && item.scrollIntoView) {
        item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    });

    document.addEventListener('shopify:block:deselect', () => {});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-atc-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class StickyAtcBar extends HTMLElement {
      constructor() {
        super();
        this.variants = [];
        this.productOptions = [];
        this.visible = false;
        this.footerObserver = null;
        this.pastThreshold = false;
        this.footerInView = false;
        this.unsubVariant = null;
        this.onScroll = this.onScroll.bind(this);
      }

      connectedCallback() {
        this.parseData();
        this.cacheElements();
        this.bindEvents();
        this.setupObservers();
        this.subscribeToVariantChanges();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        if (this.footerObserver) this.footerObserver.disconnect();
        if (this.unsubVariant) this.unsubVariant();
      }

      parseData() {
        try {
          const variantsEl = this.querySelector('[data-product-variants]');
          const optionsEl = this.querySelector('[data-product-options]');
          if (variantsEl) this.variants = JSON.parse(variantsEl.textContent);
          if (optionsEl) this.productOptions = JSON.parse(optionsEl.textContent);
        } catch (e) { /* silent */ }
      }

      cacheElements() {
        this.submitBtn = this.querySelector('.sticky-atc-bar__submit');
        this.labelEl = this.querySelector('[data-add-to-cart-text]');
        this.quantityInput = this.querySelector('.quantity__input');
        this.optionValues = Array.from(this.querySelectorAll('.sticky-atc-bar__option-value'));
      }

      bindEvents() {
        if (this.submitBtn) {
          this.submitBtn.addEventListener('click', this.onSubmit.bind(this));
        }
      }

      getThreshold() {
        const isMobile = window.innerWidth < 750;
        return isMobile
          ? parseInt(this.dataset.scrollThresholdMobile, 10) || 400
          : parseInt(this.dataset.scrollThresholdDesktop, 10) || 600;
      }

      setupObservers() {
        const footerSelector = this.dataset.footerSelector || '.shpflt-footer';
        const footerEl = document.querySelector(footerSelector);

        window.addEventListener('scroll', this.onScroll, { passive: true });

        if (footerEl) {
          this.footerObserver = new IntersectionObserver((entries) => {
            this.footerInView = entries[0].isIntersecting;
            this.updateVisibility();
          }, { threshold: 0 });
          this.footerObserver.observe(footerEl);
        }

        this.onScroll();
      }

      onScroll() {
        const past = window.scrollY >= this.getThreshold();
        if (past !== this.pastThreshold) {
          this.pastThreshold = past;
          this.updateVisibility();
        }
      }

      updateVisibility() {
        const shouldShow = this.pastThreshold && !this.footerInView;
        if (shouldShow === this.visible) return;
        this.visible = shouldShow;
        this.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      }

      subscribeToVariantChanges() {
        if (typeof subscribe !== 'function') return;
        this.unsubVariant = subscribe(PUB_SUB_EVENTS.variantChange, (data) => {
          if (!data || !data.data || !data.data.variant) return;
          this.syncVariant(data.data.variant);
        });
      }

      syncVariant(variant) {
        if (!variant) return;

        // Update labels to match
        if (variant.options) {
          for (let i = 0; i < variant.options.length; i++) {
            if (this.optionValues[i]) {
              this.optionValues[i].textContent = variant.options[i];
            }
          }
        }

        this.updateButton(variant);
      }

      updateButton(variant) {
        if (!this.submitBtn || !this.labelEl) return;
        this.submitBtn.dataset.variantId = variant.id;

        const addText = this.dataset.addToCartLabel || 'Add to cart';
        const soldOutText = this.dataset.soldOutLabel || 'Sold out';

        if (variant.available) {
          this.submitBtn.disabled = false;
          const price = formatMoney(variant.price);
          this.labelEl.innerHTML = addText + '<span class="sticky-atc-bar__price"> ' + price + '</span>';
        } else {
          this.submitBtn.disabled = true;
          this.labelEl.textContent = soldOutText;
        }
      }

      async onSubmit() {
        if (this.submitBtn.disabled) return;

        const variantId = this.submitBtn.dataset.variantId;
        const quantity = this.quantityInput ? parseInt(this.quantityInput.value, 10) || 1 : 1;

        this.submitBtn.classList.add('loading');
        const spinner = this.submitBtn.querySelector('.loading-overlay__spinner');
        if (spinner) spinner.classList.remove('hidden');

        try {
          // companion auto-add: when this sticky bar's product has a companion
          // configured and the storefront market is US, send a multi-item body
          // with the trigger first and the companion second so the cart shows
          // Balance Phone above the eSIM.
          const companionVariantId = this.dataset.companionVariantId;
          const companionCountry = this.dataset.companionCountry;
          const companionApplies = !!companionVariantId && companionCountry === 'US';

          const body = JSON.stringify(
            companionApplies
              ? {
                  items: [
                    { id: parseInt(variantId, 10), quantity: quantity },
                    { id: parseInt(companionVariantId, 10), quantity: quantity },
                  ],
                  sections: this.getSectionsToRender(),
                  sections_url: window.location.pathname,
                }
              : {
                  id: parseInt(variantId, 10),
                  quantity: quantity,
                  sections: this.getSectionsToRender(),
                  sections_url: window.location.pathname,
                }
          );

          const response = await fetch(window.Shopify?.routes?.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: body,
          });

          const data = await response.json();

          if (data.status) {
            // Error
            if (typeof publish === 'function') {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'sticky-atc-bar',
                productVariantId: variantId,
                errors: data.description,
                message: data.message,
              });
            }
          } else {
            // Success
            if (typeof publish === 'function') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'sticky-atc-bar',
                productVariantId: variantId,
              });
            }
            // Open cart drawer if available
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
              cartDrawer.renderContents(data);
            } else {
              window.location.href = window.Shopify?.routes?.root + 'cart';
            }
          }
        } catch (e) {
          console.error('Sticky ATC error:', e);
        } finally {
          this.submitBtn.classList.remove('loading');
          const spinner = this.submitBtn.querySelector('.loading-overlay__spinner');
          if (spinner) spinner.classList.add('hidden');
        }
      }

      getSectionsToRender() {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && cartDrawer.getSectionsToRender) {
          return cartDrawer.getSectionsToRender().map(s => s.id);
        }
        return [];
      }
    }

    if (!customElements.get('sticky-atc-bar')) {
      customElements.define('sticky-atc-bar', StickyAtcBar);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
